
type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
};
const TotalSentEmailIcon = function TotalSentEmailIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="total-sent-email-icon">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.22372 5.84108L5.68216 8.2095L8.07857 12.6159C8.15457 12.7535 8.29896 12.8412 8.45855 12.8412H8.48895C8.65867 12.8287 8.80307 12.721 8.86386 12.5633L12.9702 1.5499C13.0284 1.39467 12.9904 1.21942 12.8714 1.10175C12.7523 0.984082 12.575 0.946528 12.4179 1.00411L1.27945 5.06497C1.11986 5.12255 1.01093 5.26776 0.998268 5.4355C0.985602 5.60324 1.07426 5.76097 1.22372 5.84108ZM8.38257 11.3791L6.5308 7.97165L11.4832 3.0771L8.38257 11.3791ZM5.92281 7.36829L10.8727 2.47373L2.47259 5.53815L5.92281 7.36829Z" fill={fillColor} />
    </svg>
  );
};
TotalSentEmailIcon.defaultProps = defaultProps;
export default TotalSentEmailIcon;